/**
 * Momentjs filter wrapper
 * ========================
 * For now only done for duration humanize
 *
 * added humanizeDurationJS as momentJS's humanizing is not accurate enough and might never be
 * https://github.com/moment/moment/issues/348
 * https://github.com/EvanHahn/HumanizeDuration.js
 *
 */
export default function momentFilter() {
  return function(input, format) {
    if (!format) {
      format = 'L';
    }
    return moment(input).format(format);
  };
}



// WEBPACK FOOTER //
// ./src/app/common/moment.filter.js